/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
// Import PolymerElement class
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class taxIdentifierInput extends mixinBehaviors([sbBehaviours.authAndSubmit, accessibilityBehaviours.commonFunctions, corpBehaviours.appCommonBehaviour], PolymerElement) {
  static get template() {
    return html`
         
          <style  include="app-styles"> 
          .buttonHeight{
            position: relative;
            margin-top: 85%;
          } 
          .buttonPosition{
            position: absolute;
            align-content: center;
            bottom: 0;
            padding-bottom: 32px;
          }
         </style>
         <app-media-query phone={{phone}} tablet={{tablet}} desktop={{desktop}}></app-media-query>
          <div class="mdl-grid mdl-grid--no-spacing" hidden$={{phone}}>
            <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col content-align-left text-align-left">
              <div hidden$="{{displayIcon(leftAction.leftIcon)}}">
                <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}">
                  <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
                </a>
                <div hidden$="{{!leftAction.leftCallback}}">
                  <paper-icon-button id="primary_account_back_button" icon="{{leftAction.leftIcon}}" on-tap="_confirmBack"  aria-label$="{{getLabel('l_Back')}}" role="button" class="action-btn-rtl"></paper-icon-button>
                </div>
              </div>
            </div>
            <div class="outlineOffset mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark" tabindex=0 id="pannumber_edit_page_title">
              <oe-i18n-msg msgid="{{titlePage}}"></oe-i18n-msg>
            </div>
          </div>
          <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col">
                <app-tax-identifier id="MyprofiletaxIdentifier" tax-identifier-add-success-label="{{taxIdentifierAddSuccessLabel}}" tax-identifier-update-success-label="{{taxIdentifierUpdateSuccessLabel}}" tax-identifier-update-page-title="{{taxIdentifierUpdatePageTitle}}" tax-identifier-add-page-title="{{taxIdentifierAddPageTitle}}" tax-identifier-success-label="{{taxIdentifierSuccessLabel}}" is-valid-tax-input="{{isValidTaxInput}}" entered-value="{{enteredValue}}" tax-identifier-label="{{taxIdentifierLabel}}"></app-tax-identifier>
            </div>
          </div>
          <template is="dom-if" if="{{phone}}">
          <div class="mdl-grid">
            <div class="buttonPosition mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="tax-identifier_confirm_btn" on-keydown="setFocus" on-tap="confirm" class="primary-button primary-light-color">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>
        <template is="dom-if" if="{{!phone}}">
          <div class="mdl-grid buttonHeight">
            <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
              <paper-button id="tax-identifier_confirm_btn" on-keydown="setFocus" on-tap="confirm" class="primary-button">
                <oe-i18n-msg msgid="b_Update" class="style-scope"></oe-i18n-msg>
              </paper-button>
            </div>
          </div>
        </template>

        <!-- app dialog for authorization i.e. transaction  password -->
        <app-dialog name="h_Authorization" id="taxUpdateAuthorization" elementid="taxUpdateAuthorization">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                <fin-auth-element-wrapper id="loan_acct_tax_form_authPaymentStopWrapper" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitTaxFormAuthsubmit" on-tap="_continueToConfirm" on-keypress="_continueToConfirm" class="flat-button">
                  <oe-i18n-msg id="taxSubmitButton" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
          
        <!-- Back navigation popup -->
        <app-dialog id="backNagigationPopup" closevisible="{{closevisible}}" elementid="backNagigationPopup">
          <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                <oe-i18n-msg msgid="m_backNavigationError" class="font-size-m"></oe-i18n-msg>
              </div>
              <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                <paper-button id="submitTaxFormAuthsubmit" on-tap="_leftAction" on-keypress="_leftAction" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                </paper-button>
                <paper-button id="submitTaxFormAuthsubmit" on-tap="_cancelBack" on-keypress="_cancelBack" class="flat-button">
                  <oe-i18n-msg id="loan_acct_email_form_emailLoanSubmitButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                </paper-button>
              </div>
          </div>
        </app-dialog>
          `;
  }

  static get properties() {
    return {
      //Iron page selector for pages in profile-main
      myprofilepagenumber: {
        type: Number,
        notify: true,
        observer: 'resetAuth'
      },
      //Variale to store the Tax Label
      taxIdentifierLabel: {
        type: String,
        notify: true
      },
      //page Title variable in header
      titlePage: {
        type: String,
        notify: true
      },
      //Variable to store value entered by user
      enteredValue: {
        type: String,
        notify: true,
        observer: '_checkPanValidity'
      },
      //To check input field is invalid
      invalid: {
        type: Boolean,
        notify: true
      },
      //Boolean variable for disabling th update variable
      hideConfirmBtn: {
        type: Boolean,
        value: true
      },
      //To store authentication methods
      authMethods: {
        type: Array,
        notify: true
      },
      //To hide close button from back navigation popup
      closevisible: {
        type: Boolean,
        value: false
      },
      //To store all the tax details
      taxDetails: {
        type: Object,
        notify: true,
        observer: 'gotTaxDetails'
      },
      //Variable to store initial tax valu
      originalTaxValue: {
        type: String,
        notify: true
      },
      //The variable is true when the enteredValue is valid tax input else false
      isValidTaxInput: {
        type: Boolean,
        notify: true
      },
      taxIdentifierSuccessLabel: {
        type: String,
        notify: true
      },
      //Label to store the page title when user is adding a new PAN
      taxIdentifierAddPageTitle: {
        type: String,
        notify: true
      },
      //Label to store the page title when user is updating a new PAN
      taxIdentifierUpdatePageTitle: {
        type: String,
        notify: true
      },
      taxIdentifierAddSuccessLabel: {
        type: String,
        notify: true
      },
      taxIdentifierUpdateSuccessLabel: {
        type: String,
        notify: true
      }
    };
  }

  //Function called when tax details are recieved
  gotTaxDetails() {
    if (this.taxDetails) {
      this.originalTaxValue
      this.enteredValue = this.taxDetails.taxId;
      this.originalTaxValue = _.cloneDeep(this.enteredValue);

    }
  }

  //To reset authmethods
  resetAuth(n) {
    if (n == 12) this.authMethods = [];
  }

  //To check if user has changed the values
  _confirmBack() {
    if (String(this.originalTaxValue) == String(this.enteredValue)) {
      if (this.phone && $('.mainContent') !== undefined) {
      $('#index_HeaderPanel')[0].children[1].style.removeProperty('margin-top');
      $('.mainContent')[0].style.removeProperty('margin-bottom');
      $('#index_HeaderPanel')[0].children[1].classList.add('page-container-min-height');
      }
      this.myprofilepagenumber = 0;
    } else {
      this.$.backNagigationPopup.$$("#backNagigationPopup").open();
    }
  }

  //cancel back navigation
  _cancelBack() {
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
  }

  //Function called when user clicks on yes in back navigation popup
  _leftAction() {
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
    this.myprofilepagenumber = 0;
  }

  //To display back icon
  displayIcon(value) {
    if (value == "") return true;
    return false;
  }

  //To enable or disable the update button
  _checkPanValidity() {
    if (this.isValidTaxInput == false) {
      this.hideConfirmBtn = false;
    } else {
      this.hideConfirmBtn = true;
    }
  }

  confirm() {
    if (this.$$("#MyprofiletaxIdentifier") && this.$$("#MyprofiletaxIdentifier").$$("#taxInputArea")) {
      if (!this.$$("#MyprofiletaxIdentifier").$$("#taxInputArea").validate()) {
        return false;
      }
      else {
    if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
      this.authMethods = [];
      this.header = [];
    }
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/tax-number';
    ajaxCall.method = 'POST';
    ajaxCall.body = {
      "taxId": this.enteredValue.toUpperCase()
    };
    oeAjaxEventListner(ajaxCall);
    this.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, this.header);
  }
    }
  } //To open auth page to enter Txn password

  //To open auth page to enter Txn password
  _callAuthPage() {
    this.$.taxUpdateAuthorization.$$("#taxUpdateAuthorization").open();
  }

  //To display success toast
  _callSucessPage() {
    this.$.taxUpdateAuthorization.$$("#taxUpdateAuthorization").close();
    this.myprofilepagenumber = 0;
    this.fire('oe-show-success', {
      message: this.taxIdentifierSuccessLabel
    });
  }

  //To set the auth methods
  _continueToConfirm() {
    if (this.authenticationValidation(this.authMethods)) return;
    if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

    if (this.authMethods && this.authMethods.length == 2) {
      this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
      this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
    }

    this.confirm();
  }

  connectedCallback() {
    super.connectedCallback();
  }
  //Manually Focused on Header
  _focusOnTitle() {
    setTimeout(function () {
      this.$$("#pannumber_edit_page_title").setAttribute("tabindex", "0");
      this.$$("#pannumber_edit_page_title").focus();
    }.bind(this), 0);
    if (this.phone && $('.mainContent') !== undefined) {
      $('.mainContent')[0].style.marginBottom = "0px";
      $('#index_HeaderPanel')[0].children[1].style.marginTop = "8px";
      $('#index_HeaderPanel')[0].children[1].classList.remove('page-container-min-height');
  }
  }
  setFocus(event) {
    if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
      this.shadowRoot.querySelector("#pannumber_edit_page_title").focus();
    }
  }

} // Associate the new class with an element name


customElements.define('tax-identifier-input', taxIdentifierInput);